import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Process } from "@/components/Process";
import { WhyChoose } from "@/components/WhyChoose";
import { Coverage } from "@/components/Coverage";
import { Booking } from "@/components/Booking";
import { TrackBooking } from "@/components/TrackBooking";
import { Footer } from "@/components/Footer";

export default function Landing() {
  const [service, setService] = useState("plumbing");

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = undefined;
    };
  }, []);

  return (
    <div className="relative" data-testid="landing-page">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services onSelectService={setService} />
        <Process />
        <WhyChoose />
        <Coverage />
        <Booking service={service} setService={setService} />
        <TrackBooking />
      </main>
      <Footer />
    </div>
  );
}
